<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3008 13.2758C16.1174 13.0924 16.0258 12.8591 16.0258 12.5758C16.0258 12.2924 16.1174 12.0591 16.3008 11.8758L18.1758 10.0008H12.0008C11.7174 10.0008 11.4799 9.90495 11.2883 9.71328C11.0966 9.52161 11.0008 9.28411 11.0008 9.00078C11.0008 8.71745 11.0966 8.47995 11.2883 8.28828C11.4799 8.09661 11.7174 8.00078 12.0008 8.00078H18.1758L16.3008 6.12578C16.1174 5.94245 16.0258 5.70495 16.0258 5.41328C16.0258 5.12161 16.1174 4.88411 16.3008 4.70078C16.4841 4.51745 16.7174 4.42578 17.0008 4.42578C17.2841 4.42578 17.5174 4.51745 17.7008 4.70078L21.3008 8.30078C21.4008 8.40078 21.4716 8.50911 21.5133 8.62578C21.5549 8.74245 21.5758 8.86745 21.5758 9.00078C21.5758 9.13411 21.5549 9.25911 21.5133 9.37578C21.4716 9.49245 21.4008 9.60078 21.3008 9.70078L17.7008 13.3008C17.5174 13.4841 17.2841 13.5716 17.0008 13.5633C16.7174 13.5549 16.4841 13.4591 16.3008 13.2758ZM6.30078 19.3008L2.70078 15.7008C2.60078 15.6008 2.52995 15.4924 2.48828 15.3758C2.44661 15.2591 2.42578 15.1341 2.42578 15.0008C2.42578 14.8674 2.44661 14.7424 2.48828 14.6258C2.52995 14.5091 2.60078 14.4008 2.70078 14.3008L6.30078 10.7008C6.48411 10.5174 6.71745 10.4258 7.00078 10.4258C7.28411 10.4258 7.51745 10.5174 7.70078 10.7008C7.88411 10.8841 7.97578 11.1216 7.97578 11.4133C7.97578 11.7049 7.88411 11.9424 7.70078 12.1258L5.82578 14.0008H12.0008C12.2841 14.0008 12.5216 14.0966 12.7133 14.2883C12.9049 14.4799 13.0008 14.7174 13.0008 15.0008C13.0008 15.2841 12.9049 15.5216 12.7133 15.7133C12.5216 15.9049 12.2841 16.0008 12.0008 16.0008H5.82578L7.70078 17.8758C7.88411 18.0591 7.97578 18.2924 7.97578 18.5758C7.97578 18.8591 7.88411 19.0924 7.70078 19.2758C7.51745 19.4591 7.28411 19.5549 7.00078 19.5633C6.71745 19.5716 6.48411 19.4841 6.30078 19.3008Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#E10E1C",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
